import { createReducer, on } from '@ngrx/store';
import { ProductActions } from 'src/app/core/state/app.actions';
import { STATE_STATUS } from 'src/app/shared/models';
import { ProductState } from './product.state';

export const TAG = 'product';

export interface FiltersType {
	structureUUID?: string;
	featureValue?: string[];
	communityUUID?: string;
	active?: boolean;
  status?: string;
	updateDate?: string;
	communityEntityUUID?: string;
	[key: string]: unknown;
}

const initialState: ProductState = {
	filters: {
		featureValue: [],
		active: undefined,
    status: undefined
	},
	sort: undefined,
	pages: [0],
	data: { totalProductsCount: 0, products: [] },
	features: [],
	structures: [],
	status: STATE_STATUS.UNKNOWN,
	gridSearch: null,
	deleteStatus: 'unknown',
	cachedPages: []
};

export const counterReducer = createReducer(
	initialState,
	/**
	 * Parte standard di un reducer
	 */
	on(ProductActions.setSort, (state: ProductState, { sort }) => ({
		...state,
		sort,
	})),
	on(ProductActions.setPages, (state: ProductState, { pages }) => ({
		...state,
		pages,
	})),
	on(ProductActions.setProductsSuccess, (state: ProductState, { data }) => {
		return {
			...state,
			status: STATE_STATUS.READY,
			data: {
				products: data.products,
				totalProductsCount: data.totalProductsCount,
			},
			pages: [...state.cachedPages, ...data.pages],
		};
	}),
	on(ProductActions.setProductsError, (state: ProductState) => ({
		...state,
		status: STATE_STATUS.ERROR,
	})),
	on(ProductActions.setStatus, (state: ProductState, { status }) => {
		return {
			...state,
			status,
		};
	}),
	on(ProductActions.setGridSearch, (state: ProductState, { search }) => {
		return {
			...state,
			gridSearch: search,
		};
	}),
	on(ProductActions.setDeleteProducts, (state: ProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.LOADING,
		};
	}),
	on(ProductActions.setDeleteProductsSuccess, (state: ProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.READY,
		};
	}),
	on(ProductActions.setDeleteProductsError, (state: ProductState) => {
		return {
			...state,
			deleteStatus: STATE_STATUS.ERROR,
		};
	}),
	/**
	 * PARTE SPECIFICA DEL REDUCER
	 */
	on(ProductActions.setFilters, (state: ProductState, { filters }) => ({
		...state,
		filters: {
			...filters,
			structureUUID: filters.structureUUID !== 'allStructures' ? filters.structureUUID : undefined,
			communityUUID: filters.communityEntityUUID,
		},
	})),
	on(ProductActions.setStructures, (state: ProductState, { structures }) => ({
		...state,
		structures,
	})),
	on(ProductActions.setFeatures, (state: ProductState, { features }) => ({
		...state,
		features,
	})),
	on(ProductActions.updateFilters, (state: ProductState, { updatedFilters }) => ({
		...state,
		filters: {
			...state.filters,
			...updatedFilters,
		},
	})),
	on(ProductActions.addFeatureValueToFilters, (state: ProductState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.concat(featureValueUUID),
		},
	})),
	on(ProductActions.removeFeatureValueFromFilters, (state: ProductState, { featureValueUUID }) => ({
		...state,
		filters: {
			...state.filters,
			featureValue: state.filters.featureValue?.filter((uuid) => uuid !== featureValueUUID),
		},
	})),
	on(ProductActions.setCachedPages, (state: ProductState, { pages }) => ({
		...state,
		cachedPages: [...new Set([...state.cachedPages, ...pages])],
	})),
	on(ProductActions.resetCache, (state: ProductState) => ({
			...state,
      status: STATE_STATUS.READY,
			cachedPages: [],
			pages: [0],
			data: { totalProductsCount: 0, products: [] },
	})),
);
